module.exports = __webpack_public_path__ + "assets/img/none.71e61bfe.png";